import { createFileRoute } from "@tanstack/react-router";

import { ArtifactDashboardPage } from "../tools/dashboards/artifacts/ArtifactDashboardPage";

function CustomDashboardRoute() {
  const { slug } = Route.useParams();
  return <ArtifactDashboardPage key={slug} slug={slug} />;
}

export const Route = createFileRoute("/_app/dashboards/custom/$slug")({
  component: CustomDashboardRoute,
});
